import { createApiRef } from '@backstage/core-plugin-api';
import { AccountMapping, UsageResponse, UserActivityResponse } from '../types';

export type ValidWindow = 7 | 30 | 90 | 'mtd';

export const claudeUsageApiRef = createApiRef<ClaudeUsageApi>({
  id: 'plugin.claude-usage.service',
});

export interface ClaudeUsageApi {
  getUsage(usageWindow: ValidWindow): Promise<UsageResponse>;
  getUserActivity(): Promise<UserActivityResponse>;
  getAccountMappings(): Promise<AccountMapping[]>;
  addCategoryMapping(mapping: AccountMapping): Promise<AccountMapping[]>;
  invalidateCache(): Promise<void>;
}
